<template>
  <div class="m_publication">
    <div class="m_publication--publi">
      <transition name="fade">
        <PagedPublicationTemplate
          v-if="show_publis"
          v-show="!$root.current_publication_opened"
          :publication="publication"
          :mode="'stacked'"
          :zoom="0.5"
          :show_page="1"
        />
      </transition>
    </div>
    <div class="m_publication--text">
      <div class="m_publication--name">{{ publication.name }}</div>

      <div class="m_publication--meta">
        créé
        <span v-if="publi_authors && publi_authors.length > 0"
          >par {{ $root.formatListToHuman(publi_authors) }}</span
        >
        le {{ $root.formatDateToHuman(publication.date_created) }}
      </div>

      <div v-if="readKeywords(publication.keywords).length > 0">
        <span
          v-html="
            readKeywords(publication.keywords).length === 1
              ? 'Mot-clé&nbsp;'
              : 'Mots-clés&nbsp;'
          "
        />
        <span
          v-for="(kw, index) in readKeywords(publication.keywords)"
          :key="index"
        >
          <button type="button" disabled>
            <template v-if="index > 0">•</template>
            {{ kw }}
          </button>
        </span>
      </div>

      <div class="m_publication--buttons">
        <button
          type="button"
          @click="
            $root.state.modal.current_publication_slug =
              publication.slugFolderName
          "
        >
          ouvrir
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import PagedPublicationTemplate from "./PagedPublicationTemplate.vue";
export default {
  props: {
    publication: Object,
  },
  components: {
    PagedPublicationTemplate,
  },
  data() {
    return {
      show_publis: false,
    };
  },
  created() {},
  mounted() {
    setTimeout(() => {
      this.show_publis = true;
    }, 1000);
  },
  beforeDestroy() {},
  watch: {},
  computed: {
    publi_authors() {
      const slugs = this.publication.authors.reduce((acc, a) => {
        if (a.slugFolderName) acc.push(a.slugFolderName);
        return acc;
      }, []);

      return slugs.reduce((acc, s) => {
        if (this.$root.authors.hasOwnProperty(s)) {
          acc.push(this.$root.authors[s].name);
        }
        return acc;
      }, []);
    },
  },
  methods: {
    readKeywords(kw) {
      if (!kw) return [];
      return kw.map((k) => k.title);
    },
  },
};
</script>
<style lang="scss" scoped>
.m_publication {
  position: relative;
  background-color: #f9f9f9;
  background-color: white;
  border-radius: 4px;

  &:hover {
    ::v-deep .m_pagedPublicationTemplate {
      transform: translate(0, calc(-1 * var(--spacing)));
    }
  }
}

.m_publication--publi {
  padding: calc(var(--spacing) * 3) calc(var(--spacing) * 2);
  height: 300px;
  overflow: hidden;
  border-bottom: 2px solid var(--logo-blue);
  // background-color: #333;
  // background-color: white;
  background-color: var(--logo-blue_lighterer);

  ::v-deep .m_pagedPublicationTemplate {
    transition: all 0.4s cubic-bezier(0.19, 1, 0.22, 1);
  }
}

.m_publication--text {
  padding: 0 var(--spacing) var(--spacing) 0;

  > * {
    max-width: 44ch;
    margin: calc(var(--spacing) / 3) 0;
  }
}

.m_publication--authors {
  // // color: var(--logo-blue_lighter);
  // font-size: 0.8rem;
}

.m_publication--name {
  font-weight: 700;
  font-size: 1.4rem;
}

.m_publication--meta {
  font-family: "Alegreya", Georgia, serif;
  max-width: 54ch;
  // font-size: 0.9rem;
}

.m_publication--buttons {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 10;
  margin: var(--spacing);
}
</style>
